import { render, staticRenderFns } from "./staiff_info.vue?vue&type=template&id=c7046ef8&scoped=true"
import script from "./staiff_info.vue?vue&type=script&lang=js"
export * from "./staiff_info.vue?vue&type=script&lang=js"
import style0 from "./staiff_info.vue?vue&type=style&index=0&id=c7046ef8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7046ef8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7046ef8')) {
      api.createRecord('c7046ef8', component.options)
    } else {
      api.reload('c7046ef8', component.options)
    }
    module.hot.accept("./staiff_info.vue?vue&type=template&id=c7046ef8&scoped=true", function () {
      api.rerender('c7046ef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/staiff_info/staiff_info.vue"
export default component.exports